module.exports = __webpack_public_path__ + "img/113.3084b305.png";